import { useLocalStorageStringState } from './useLocalStorageState';
import { singletonHook } from 'react-singleton-hook';

const useLayoutConfigSetting = () =>
	useLocalStorageStringState('layoutSetting', 'default');

export default singletonHook([undefined, undefined], useLayoutConfigSetting);
